import {TablePagination} from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid";

function Pagination({count, page, changePage}) {
    
    const handleChangePage = (event, newPage) => {
        changePage(newPage)
    };

    return (
        <Grid>
            <TablePagination
                rowsPerPageOptions={[5]}
                component="div"
                count={count}
                rowsPerPage={10}
                page={page}
                onPageChange={handleChangePage}
            />
        </Grid>
    );
}
export default Pagination;
